import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { NGXLogger } from 'ngx-logger';
import { catchError, Observable, of, switchMap } from 'rxjs';

import { BaseUrlService } from '../../../auth/authentication/base-url.service';
import { ValidationService } from '../../utils/valibot/validation.service';
import { Version, VersionSchema } from './model/version.model';

@Injectable({ providedIn: 'root' })
export class VersionClient {
  private static readonly versionFilePath = `/version.json`;

  private readonly http = inject(HttpClient);
  private readonly logger = inject(NGXLogger);
  private readonly validationService = inject(ValidationService);

  private readonly baseUrl$ = toObservable(inject(BaseUrlService).baseUrlSetByInput);

  getVersion(): Observable<Version | undefined> {
    const url = VersionClient.versionFilePath;
    this.logger.info(`#CDFTF0224 Loading application version from ${url}`);

    // in initialization phase the baseUrlService.baseUrlSetByInput is not set yet.
    // If a base URL is set, the version need to be reloaded. (The first load fails in this case.)
    return this.baseUrl$.pipe(
      switchMap(() =>
        this.http.get(url).pipe(
          this.validationService.pipeResponse(VersionSchema),
          catchError((err) => {
            this.logger.error('#CDFTF0225 Unable to load application version.', err);
            return of(undefined);
          }),
        ),
      ),
    );
  }
}
